.container {
  height: calc(100% - 11.4rem);

  & > div {
    background-color: var(--color-grayscale-eerie-black);

    & > div {
      background-size: 65%;

      & > div {
        max-width: unset;

        & > p {
          font-size: 2.4rem;
          font-weight: 600;
          width: 100%;
          margin-bottom: 0.8rem;

          @media screen and (min-width: $bp-small) {
            font-size: 4.8rem;
            font-weight: 700;
            margin-bottom: 2.4rem;
          }
        }
      }
    }
  }
}

.logo {
  padding-top: 5.2rem;

  & svg {
    display: block;
    margin: 0 auto;
  }
}
